export default __webpack_public_path__ + "static/media/avatar_merlion1.bea99caa.mp3";